<mat-dialog-content style="text-align:center;">{{ data.message }}</mat-dialog-content>
<mat-dialog-actions style="text-align:center;">
  <button mat-raised-button (click)="close()">OK!</button>
</mat-dialog-actions>

